import { defineStore } from 'pinia';
import User from '@/models/User/user';
import UserService from '@/services/user.service.js';

export const useUserStore = defineStore('user', {
  state: () => ({
    currentUser: null,
  }),
  actions: {
    setCurrentUser(currentUser) {
      this.currentUser = User.createFromObject(currentUser);
    },
    clearUser() {
      this.currentUser = null;
    },
    async settingsComplete({ email, locale }) {
      await UserService.updateUserSettings(email, locale);
      if (this.currentUser) {
        this.currentUser.settingsUpdatedAt = new Date();
      }
    },
  },
  persist: {
    serializer: {
      serialize: (state) => JSON.stringify(state),
      deserialize: (data) => {
        const parsed = JSON.parse(data);

        return {
          currentUser: parsed.currentUser ? User.createFromObject(parsed.currentUser) : null,
        };
      },
    },
  },
});
